import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyEnglishResumeFormatData,
  provideEnglishResumeFormatData,
  provideEnglishResumeHistories,
  useEnglishResumeHistories
} from '@/composables/format-edit/useEnglishResumeFormatData'
import EnglishResumeProfileCard from '@/components/format-edit/english-resume/EnglishResumeProfileCard.vue'
import EnglishResumeAddressCard from '@/components/format-edit/english-resume/EnglishResumeAddressCard.vue'
import EnglishResumeEduHistoryCard from '@/components/format-edit/english-resume/EnglishResumeEduHistoryCard.vue'
import EnglishResumeSkillsCard from '@/components/format-edit/english-resume/EnglishResumeSkillsCard.vue'
import EnglishResumeLicenseCard from '@/components/format-edit/english-resume/EnglishResumeLicenseCard.vue'
import EnglishResumeJobHistoryCard from '@/components/format-edit/english-resume/EnglishResumeJobHistoryCard.vue'
import EnglishResumePrMessageCard from '@/components/format-edit/english-resume/EnglishResumePrMessageCard.vue'
import EnglishResumeCreateDateCard from '@/components/format-edit/english-resume/EnglishResumeCreateDateCard.vue'
import DownloadItem from '@/components/formats/CommonParts/DownloadItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumeEdit',
  props: {
    basicData: null,
    formatId: null,
    currentCardId: null
  },
  setup(__props: any) {



const { formLib } = useHostServices()

const { formatData } = useFormatLocalData({
  saveName: 'english_resume',
  saveOtherName: 'rirekisho',
  createEmpty: createEmptyEnglishResumeFormatData
})
provideEnglishResumeFormatData(formatData)

const histories = useEnglishResumeHistories(formatData)
provideEnglishResumeHistories(histories)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiPostEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)
const downloadActiveCollapses = ref(['postcard'])

const getMode = computed(() => process.env.VUE_APP_MODE)

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

return { __sfc: true,formLib, formatData, histories, mailPdfEnabled, downloadPdfEnabled, isSendYagiPostEnabled, isSendYagiEmailEnabled, downloadActiveCollapses, getMode, dataChanged, EnglishResumeProfileCard, EnglishResumeAddressCard, EnglishResumeEduHistoryCard, EnglishResumeSkillsCard, EnglishResumeLicenseCard, EnglishResumeJobHistoryCard, EnglishResumePrMessageCard, EnglishResumeCreateDateCard, DownloadItem }
}

})